import React, { PureComponent } from 'react';
import * as R from 'ramda';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import Button from 'reactstrap/lib/Button';
import PropTypes from 'prop-types';

import { FormattedTag } from 'core/components';
import {
  isEmptyOrNil, createUrlSlug,
  // wrapRoute2Locale,
} from 'core/helpers';

import { ModalWindow } from 'components/modal-window/modal-window';
import { producerIcons, UnknownProducerIcon } from 'components/games-filters/producer-icons';
import { IconProducerChecked } from 'components/icons/icon-producer-checked/icon-producer-checked';

import { MODAL_IDS } from '../../../constants';

import './producers-modal.scss';

export class ProducersModal extends PureComponent {
  scrollSubscription$;
  getExternalContent = () => (
    <div className="producers-modal-button-wrap position-fixed w-100 p-2">
      <Button
        className="clear-btn"
        color="green"
        onClick={this.clearProducers}
        outline
        block
      >
        <FormattedTag id="clear-all" />
      </Button>

      <FormattedTag
        id="games.search.btn-apply"
        disabled={isEmptyOrNil(this.props.filterProducers)}
        tag={Button}
        color="secondary"
        className="w-100 submit-btn"
        onClick={this.onSubmit}
        values={{ gamesAmount: this.props.filteredGames.length }}
      />
    </div>
  );

  onClosed = () => {
    if (this.scrollSubscription$) {
      this.scrollSubscription$.unsubscribe();
    }
  }

  closeModal = () => {
    const { closeModal } = this.props;
    closeModal(MODAL_IDS.PRODUCERS);
  };

  onSubmit = () => {
    const { setProducers, closeModal } = this.props;

    setProducers(this.props.filterProducers);
    closeModal(MODAL_IDS.PRODUCERS);
  }

  clearProducers = () => {
    const { setProducers } = this.props;
    setProducers([]);

    this.closeModal();

    // const { clearAllFilters } = this.props;
    // clearAllFilters();
    // this.closeModal();
    // this.nextPath('/games/all');
  }

  onChange = ({ currentTarget: { dataset: { producer } } }) => {
    const { setProducers } = this.props;

    const newProducers = R.ifElse(
      R.includes(producer),
      R.without([producer]),
      R.append(producer),
    )(this.props.filterProducers);

    setProducers(newProducers);
  }
  // nextPath(path) {
  //   const { history, locale } = this.props;
  //   history.push(wrapRoute2Locale(path, locale));
  // }

  render() {
    const { producers } = this.props;

    return (
      <ModalWindow
        id={MODAL_IDS.PRODUCERS}
        coreProps={{ id: MODAL_IDS.PRODUCERS }}
        bodyClassName="producers-modal"
        onOpened={this.onOpened}
        onClosed={this.onClosed}
        externalDialogContent={this.getExternalContent()}
        isModalCentered
        fade
        scrollable
      >
        <>
          <FormattedTag
            tag="div"
            id="producers"
            className="h3 providers-title"
          />

          <div className="w-100 px-2 pt-2_25 bg-white producers-wrap">
            {producers.map((producer) => {
              const Icon = producerIcons[createUrlSlug(producer)] || UnknownProducerIcon;
              const isChecked = this.props.filterProducers.includes(producer);

              return (
                <div
                  role="button"
                  tabIndex="0"
                  data-producer={producer}
                  onClick={this.onChange}
                  onKeyPress={this.onChange}
                  key={producer}
                  className="d-flex justify-content-between w-100 mt-2_5 cursor-pointer align-items-center"
                >
                  <div className="d-flex align-items-center">
                    <span className="producer-icon">
                      {Icon && <Icon />}
                    </span>
                    <div className={classNames('ml-1_5 letter-spacing-default text-blue-dark', { '$font-weight-bold': !isChecked })}>{producer}</div>
                  </div>

                  {isChecked && <IconProducerChecked className="rounded" />}
                </div>
              );
            })}
          </div>
        </>
      </ModalWindow>
    );
  }
}

ProducersModal.propTypes = {
  producers: PropTypes.arrayOf(PropTypes.string),
  filterProducers: PropTypes.arrayOf(PropTypes.string).isRequired,
  setProducers: PropTypes.func.isRequired,
  // clearAllFilters: PropTypes.func.isRequired,
  filteredGames: PropTypes.arrayOf(PropTypes.shape),
  closeModal: PropTypes.func.isRequired,
  // history: PropTypes.objectOf.isRequired,
  // push: PropTypes.objectOf.isRequired,
  // locale: PropTypes.string.isRequired,
};

ProducersModal.defaultProps = {
  producers: [],
  filteredGames: [],
};

export default withRouter(ProducersModal);
